// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ZWSV","location":"Header_location__2vJU5"};